module.exports = __webpack_public_path__ + "assets/img/046201.cbb92f5a.svg";